import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { forkJoin } from 'rxjs';
import { DescripcionErrorIntegracionService } from '../../_services/descripcion-error-integracion.service';
import { DescripcionErrorIntegracion } from '../../_models/descripcion-error-integracion';

@Component( {
  selector: 'app-banco-error-integracion-editar',
  templateUrl: 'banco-error-integracion-editar.component.html'
} )

export class BancoErrorIntegracionEditarComponent implements OnInit {

  carInformacionInicial = true;
  guardando = false;
  bancoError: DescripcionErrorIntegracion;
  lisBancoErrores: DescripcionErrorIntegracion[] = [];
  formulario: FormGroup;
  submitted = false;
  lisIntegraciones: SelectItem[] = [];

  constructor( private serBancoError: DescripcionErrorIntegracionService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private serListas: ListaService,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.serBancoError.listado(),
        this.serListas.getMasterDetails( 'ListasIntegraciones' ) ).subscribe( ( [ bancoError, integraciones ] ) => {
        this.lisBancoErrores = bancoError;
        if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
          this.bancoError = bancoError.find( y => y.idDescripcionErrorIntegracion === params[ 'id' ] );
          if ( !(this.bancoError && (this.bancoError.idDescripcionErrorIntegracion !== '' && this.bancoError.idDescripcionErrorIntegracion !== null && this.bancoError.idDescripcionErrorIntegracion !== undefined)) ) {
            this.navServicio.setMesage( 0, {
              severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'BANCOERROR.MSG_NOEXISREGISTRO' )
            } );
            this.location.back();
          }
        }
        integraciones.map( ( s: ListaItem ) => {
          this.lisIntegraciones.push( { label: s.nombre, value: s.idLista } );
        } );
        this.cargarFormulario();
        this.carInformacionInicial = false;
      } );
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idDescripcionErrorIntegracion: [ this.bancoError ? this.bancoError.idDescripcionErrorIntegracion : null ],
      idIntegracion: [ this.bancoError ? this.bancoError.idIntegracion : null, [ Validators.required ] ],
      codigo: [ this.bancoError ? this.bancoError.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      descripcionUsuario: [ this.bancoError ? this.bancoError.descripcionUsuario : null, [ Validators.required, Validators.maxLength( 500 ) ] ],
      descripcionTecnica: [ this.bancoError ? this.bancoError.descripcionTecnica : null, [ Validators.required, Validators.maxLength( 500 ) ] ],
      indicadorHabilitado: [ this.bancoError ? this.bancoError.indicadorHabilitado : true, [ Validators.required ] ],
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.value;
      if ( formulario.idDescripcionErrorIntegracion) {
        this.serBancoError.actualizar( formulario ).subscribe( rta => {
          this.navServicio.setMesage( 2 );
          this.guardando = false;
          this.submitted = false;
          this.location.back();
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      } else {
        if ( this.validarCodigo( formulario ) ) {
          this.serBancoError.crear( formulario ).subscribe( rta => {
            this.navServicio.setMesage( 1 );
            this.guardando = false;
            this.submitted = false;
            this.location.back();
          }, error => {
            this.navServicio.setMesage( 3 );
            this.guardando = false;
          } );
        } else {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'BANCOERROR.MSG_ERRORCODIGO' )
          } );
          this.guardando = false;
        }
      }
    }
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo( formulario: DescripcionErrorIntegracion ) {
    return !this.lisBancoErrores.find( h => h.idIntegracion === formulario.idIntegracion && h.codigo === formulario.codigo );
  }

  get f() {
    return this.formulario.controls;
  }

}
